import { postApi } from '@coconut/services/apis/utils';

export const postQuestion = ({ file, desc, subjectId, studentId, lang }) => {
  const data = new FormData();
  if (file) data.append('picture', file, file.name);
  data.append('description', desc);
  data.append('subject_id', subjectId);
  data.append('is_quiz', false);
  data.append('lang', lang);

  return postApi(`api/v2/students/${studentId}/questions`, {
    data,
  });
};



// WEBPACK FOOTER //
// ./src/scenes/UploadImage/services/apis/uploadImage.js